<template>
  <div class="dashboard-contenedor">
    <SlideBar @cambiar-estado="actualizarSidebar" />

    <div class="contenido" :class="{ 'contenido-expandido': sidebarCerrado }">

      <div class="page-header">
        <div>
          <p class="eyebrow">Administración</p>
          <h2 class="titulo">Aliados</h2>
        </div>
        <div class="header-acciones">
          <label class="toggle-eliminados">
            <input type="checkbox" v-model="mostrarEliminados">
            Mostrar eliminados
          </label>
          <button class="btn-agregar" @click="abrirModal">
            <span class="material-icons">add_business</span>
            Registrar aliado
          </button>
        </div>
      </div>

      <!-- Estado de carga -->
      <div v-if="cargando" class="estado-cargando">
        <div class="spinner"></div>
        <p>Cargando aliados...</p>
      </div>

      <!-- Estado vacío -->
      <div v-else-if="!hotelesVisibles.length" class="estado-vacio">
        <span class="material-icons estado-icon">business</span>
        <p>{{ mostrarEliminados ? 'No hay aliados eliminados.' : 'No hay aliados registrados.' }}</p>
      </div>

      <!-- Tabla de aliados -->
      <div v-else class="tabla-card">
        <div class="tabla-scroll">
          <table class="tabla">
            <thead>
              <tr>
                <th>Aliado</th>
                <th>Dirección</th>
                <th class="th-cp">C.P.</th>
                <th class="th-usuario">Usuario</th>
                <th class="th-centro th-credenciales">Credenciales</th>
                <th class="th-centro th-acciones">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="h in hotelesVisibles" :key="h.id" :class="{ 'fila-eliminada': !esActivo(h.activo) }">
                <td class="td-nombre">{{ h.nombre }}</td>
                <td>{{ h.calle }} {{ h.numero }}</td>
                <td class="td-cp">{{ h.cp }}</td>
                <td class="td-mono">{{ h.usuario }}</td>
                <td class="td-centro">
                  <div class="acciones-wrap">
                    <button class="btn-ojo" title="Restablecer contraseña" @click="regenerarPassword(h)">
                      <span class="material-icons">lock_reset</span>
                    </button>
                    <button class="btn-ojo" title="Editar usuario y contraseña" @click="editarCredenciales(h)">
                      <span class="material-icons">key</span>
                    </button>
                  </div>
                </td>
                <td class="td-centro">
                  <div class="acciones-wrap">
                    <button v-if="esActivo(h.activo)" class="btn-ojo" title="Editar datos del aliado" @click="abrirModalEditar(h)">
                      <span class="material-icons">edit</span>
                    </button>
                    <button v-if="esActivo(h.activo)" class="btn-ojo btn-eliminar" title="Eliminar aliado" @click="eliminarHotel(h)">
                      <span class="material-icons">delete</span>
                    </button>
                    <button v-else class="btn-ojo btn-restaurar" title="Restaurar aliado" @click="restaurarHotel(h)">
                      <span class="material-icons">restore_from_trash</span>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>

    <!-- ══ MODAL REGISTRO ══════════════════════════════════════ -->
    <transition name="modal">
      <div v-if="mostrarModal" class="modal-overlay" @click.self="cerrarModal">
        <div class="modal-registro">

          <div class="modal-reg-header">
            <div>
              <h3>Registrar Aliado</h3>
              <p>El usuario y contraseña se generan automáticamente</p>
            </div>
            <button class="btn-close-modal" @click="cerrarModal">
              <span class="material-icons">close</span>
            </button>
          </div>

          <form @submit.prevent="registrarHotel" class="modal-form">
            <div class="modal-body-scroll">
              <div class="modal-seccion">
                <h4 class="modal-sec-titulo">
                  <span class="material-icons">business</span>
                  Datos del aliado
                </h4>
                <div class="campo">
                  <label>Nombre del aliado <span class="req">*</span></label>
                  <input v-model.trim="hotelForm.nombre" type="text" maxlength="80"
                    placeholder="Ej. Playa Dorada" required>
                </div>
              </div>

              <div class="modal-seccion">
                <h4 class="modal-sec-titulo">
                  <span class="material-icons">location_on</span>
                  Dirección
                </h4>
                <div class="campo-grid campo-cols-2">
                  <div class="campo">
                    <label>Calle <span class="req">*</span></label>
                    <input v-model.trim="hotelForm.calle" type="text" maxlength="100"
                      placeholder="Av. Reforma" required>
                  </div>
                  <div class="campo">
                    <label>Número <span class="req">*</span></label>
                    <input v-model.trim="hotelForm.numero" type="text" maxlength="10"
                      placeholder="123" required>
                  </div>
                </div>
                <div class="campo campo-cp">
                  <label>Código Postal <span class="req">*</span></label>
                  <input v-model.trim="hotelForm.cp" type="text" maxlength="10"
                    placeholder="77500" required
                    @input="hotelForm.cp = hotelForm.cp.replace(/\D/g,'')">
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn-cancelar" @click="cerrarModal">Cancelar</button>
              <button type="submit" class="btn-registrar">
                <span class="material-icons">save</span>
                Registrar aliado
              </button>
            </div>
          </form>
        </div>
      </div>
    </transition>

    <!-- ══ MODAL EDITAR CREDENCIALES ══════════════════════════════ -->
    <transition name="modal">
      <div v-if="mostrarModalCredenciales" class="modal-overlay" @click.self="cerrarModalCredenciales">
        <div class="modal-registro">

          <div class="modal-reg-header">
            <div>
              <h3>Editar credenciales</h3>
              <p>{{ hotelEditando ? hotelEditando.nombre : '' }}</p>
            </div>
            <button class="btn-close-modal" @click="cerrarModalCredenciales">
              <span class="material-icons">close</span>
            </button>
          </div>

          <form @submit.prevent="guardarCredenciales" class="modal-form">
            <div class="modal-body-scroll">
              <div class="modal-seccion">
                <div class="campo">
                  <label>Usuario <span class="req">*</span></label>
                  <input v-model.trim="credencialesForm.usuario" type="text" maxlength="40" required>
                </div>
                <div class="campo">
                  <label>Contraseña nueva <span class="req">*</span></label>
                  <input v-model="credencialesForm.contraseña" type="text" maxlength="60" placeholder="Escribe la nueva contraseña" required>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn-cancelar" @click="cerrarModalCredenciales">Cancelar</button>
              <button type="submit" class="btn-registrar">
                <span class="material-icons">save</span>
                Guardar
              </button>
            </div>
          </form>
        </div>
      </div>
    </transition>

    <!-- ══ MODAL EDITAR ALIADO ══════════════════════════════════ -->
    <transition name="modal">
      <div v-if="mostrarModalEditar" class="modal-overlay" @click.self="cerrarModalEditar">
        <div class="modal-registro">

          <div class="modal-reg-header">
            <div>
              <h3>Editar Aliado</h3>
              <p>{{ hotelEditandoDatos ? hotelEditandoDatos.nombre : '' }}</p>
            </div>
            <button class="btn-close-modal" @click="cerrarModalEditar">
              <span class="material-icons">close</span>
            </button>
          </div>

          <form @submit.prevent="guardarEdicionHotel" class="modal-form">
            <div class="modal-body-scroll">
              <div class="modal-seccion">
                <h4 class="modal-sec-titulo">
                  <span class="material-icons">business</span>
                  Datos del aliado
                </h4>
                <div class="campo">
                  <label>Nombre del aliado <span class="req">*</span></label>
                  <input v-model.trim="editarForm.nombre" type="text" maxlength="80" required>
                </div>
              </div>

              <div class="modal-seccion">
                <h4 class="modal-sec-titulo">
                  <span class="material-icons">location_on</span>
                  Dirección
                </h4>
                <div class="campo-grid campo-cols-2">
                  <div class="campo">
                    <label>Calle <span class="req">*</span></label>
                    <input v-model.trim="editarForm.calle" type="text" maxlength="100" required>
                  </div>
                  <div class="campo">
                    <label>Número <span class="req">*</span></label>
                    <input v-model.trim="editarForm.numero" type="text" maxlength="10" required>
                  </div>
                </div>
                <div class="campo campo-cp">
                  <label>Código Postal <span class="req">*</span></label>
                  <input v-model.trim="editarForm.cp" type="text" maxlength="10" required
                    @input="editarForm.cp = editarForm.cp.replace(/\D/g,'')">
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn-cancelar" @click="cerrarModalEditar">Cancelar</button>
              <button type="submit" class="btn-registrar" :disabled="guardandoEditar">
                <span class="material-icons">{{ guardandoEditar ? 'hourglass_top' : 'save' }}</span>
                {{ guardandoEditar ? 'Guardando...' : 'Guardar cambios' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import Swal from 'sweetalert2';
import SlideBar from './SlideBar.vue';
import { getHoteles, addHotel, updateHotel, setHotelActivo, actualizarCredencialesHotel, verifyPassword } from '@/utils/api';

export default {
  name: 'AdministracionHoteles',
  components: { SlideBar },
  data() {
    return {
      sidebarCerrado: false,
      cargando: true,
      hoteles: [],
      mostrarModal: false,
      mostrarEliminados: false,
      mostrarModalCredenciales: false,
      hotelEditando: null,
      adminPasswordVerificado: '',
      credencialesForm: { usuario: '', contraseña: '' },
      hotelForm: { nombre: '', calle: '', numero: '', cp: '' },
      // Edición de hotel
      mostrarModalEditar: false,
      hotelEditandoDatos: null,
      editarForm: { nombre: '', calle: '', numero: '', cp: '' },
      guardandoEditar: false,
    };
  },
  computed: {
    hotelesVisibles() {
      return this.hoteles.filter(h => {
        const activo = this.esActivo(h.activo);
        return this.mostrarEliminados ? !activo : activo;
      });
    },
  },
  created() { this.cargarHoteles(); },
  methods: {
    actualizarSidebar(estado) { this.sidebarCerrado = estado; },
    esActivo(val) {
      return val === true || val === 1 || val === '1';
    },

    async cargarHoteles() {
      this.cargando = true;
      try {
        this.hoteles = await getHoteles();
      } catch (err) {
        console.error('Error cargando aliados:', err);
      } finally {
        this.cargando = false;
      }
    },

    abrirModal() {
      this.hotelForm = { nombre: '', calle: '', numero: '', cp: '' };
      this.mostrarModal = true;
    },

    cerrarModal() {
      this.mostrarModal = false;
      this.hotelForm = { nombre: '', calle: '', numero: '', cp: '' };
    },

    abrirModalEditar(hotel) {
      this.hotelEditandoDatos = hotel;
      this.editarForm = {
        nombre: hotel.nombre || '',
        calle: hotel.calle || '',
        numero: hotel.numero || '',
        cp: hotel.cp || '',
      };
      this.mostrarModalEditar = true;
    },

    cerrarModalEditar() {
      this.mostrarModalEditar = false;
      this.hotelEditandoDatos = null;
    },

    async guardarEdicionHotel() {
      if (!this.hotelEditandoDatos) return;
      const f = this.editarForm;
      if (!f.nombre.trim() || !f.calle.trim() || !f.numero.trim() || !f.cp.trim()) {
        Swal.fire('Campos requeridos', 'Todos los campos son obligatorios.', 'warning');
        return;
      }
      this.guardandoEditar = true;
      try {
        await updateHotel(this.hotelEditandoDatos.id, {
          nombre: f.nombre.trim(),
          calle: f.calle.trim(),
          numero: f.numero.trim(),
          cp: f.cp.trim(),
        });
        await Swal.fire({ icon: 'success', title: 'Aliado actualizado', timer: 1500, showConfirmButton: false });
        this.cerrarModalEditar();
        this.cargarHoteles();
      } catch (error) {
        Swal.fire('Error', error.message || 'No se pudo actualizar el aliado', 'error');
      } finally {
        this.guardandoEditar = false;
      }
    },

    async solicitarPasswordAdmin(mensaje) {
      const { value: adminPass, isConfirmed } = await Swal.fire({
        title: 'Verificación requerida',
        text: mensaje,
        input: 'password',
        inputPlaceholder: 'Contraseña de administrador',
        showCancelButton: true,
        confirmButtonText: 'Verificar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#133E68',
        inputAttributes: { autocomplete: 'current-password' },
      });
      if (!isConfirmed || !adminPass) return null;

      const valido = await verifyPassword(adminPass);
      if (!valido) {
        Swal.fire({ icon: 'error', title: 'Contraseña incorrecta', confirmButtonColor: '#133E68' });
        return null;
      }
      return adminPass;
    },

    async registrarHotel() {
      const { nombre, calle, numero, cp } = this.hotelForm;
      if (!nombre || !calle || !numero || !cp) {
        Swal.fire({ icon: 'warning', title: 'Faltan datos', text: 'Completa todos los campos.', confirmButtonColor: '#133E68' });
        return;
      }

      let creado;
      try {
        creado = await addHotel({ nombre, calle, numero, cp });
      } catch (error) {
        Swal.fire({ icon: 'error', title: 'No se pudo registrar', text: error.message, confirmButtonColor: '#d33' });
        return;
      }

      this.cerrarModal();
      this.cargarHoteles();

      Swal.fire({
        icon: 'success',
        title: 'Hotel registrado',
        html: `
          <div style="margin-bottom:10px">
            <div style="font-size:11px;color:#999;text-transform:uppercase;letter-spacing:1px;margin-bottom:3px">Usuario</div>
            <div style="font-size:17px;font-weight:700;color:#133E68;font-family:monospace">${creado.usuario}</div>
          </div>
          <div>
            <div style="font-size:11px;color:#999;text-transform:uppercase;letter-spacing:1px;margin-bottom:3px">Contraseña</div>
            <div style="font-size:18px;font-weight:800;letter-spacing:3px;color:#133E68;background:#F4EFEB;padding:10px 14px;border-radius:8px">${creado['contraseña']}</div>
          </div>
        `,
        confirmButtonText: 'Cerrar',
        confirmButtonColor: '#133E68',
      });
    },

    async regenerarPassword(hotel) {
      const adminPass = await this.solicitarPasswordAdmin('Ingresa tu contraseña de administrador para cambiar la contraseña de este aliado');
      if (!adminPass) return;

      const { value: nuevaContrasena, isConfirmed } = await Swal.fire({
        title: `Nueva contraseña — ${hotel.nombre}`,
        input: 'text',
        inputPlaceholder: 'Escribe la nueva contraseña',
        showCancelButton: true,
        confirmButtonText: 'Guardar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#133E68',
        inputValidator: (value) => (!value || value.length < 6) ? 'Mínimo 6 caracteres.' : undefined,
      });
      if (!isConfirmed || !nuevaContrasena) return;

      try {
        await actualizarCredencialesHotel(hotel.id, adminPass, hotel.usuario, nuevaContrasena);
      } catch (error) {
        Swal.fire({ icon: 'error', title: 'No se pudo actualizar', text: error.message, confirmButtonColor: '#d33' });
        return;
      }

      Swal.fire({ icon: 'success', title: 'Contraseña actualizada', confirmButtonColor: '#133E68' });
    },

    async eliminarHotel(hotel) {
      const { isConfirmed } = await Swal.fire({
        icon: 'warning',
        title: '¿Eliminar aliado?',
        text: `"${hotel.nombre}" dejará de poder iniciar sesión, pero sus datos y consultas se conservan. Puedes restaurarlo cuando quieras.`,
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#d33',
      });
      if (!isConfirmed) return;
      await setHotelActivo(hotel.id, false);
      this.cargarHoteles();
      Swal.fire({ icon: 'success', title: 'Aliado eliminado', confirmButtonColor: '#133E68' });
    },

    async restaurarHotel(hotel) {
      await setHotelActivo(hotel.id, true);
      this.cargarHoteles();
      Swal.fire({ icon: 'success', title: 'Aliado restaurado', confirmButtonColor: '#133E68' });
    },

    async editarCredenciales(hotel) {
      const adminPass = await this.solicitarPasswordAdmin('Ingresa tu contraseña de administrador para editar las credenciales');
      if (!adminPass) return;

      this.adminPasswordVerificado = adminPass;
      this.hotelEditando = hotel;
      this.credencialesForm = { usuario: hotel.usuario, contraseña: '' };
      this.mostrarModalCredenciales = true;
    },

    cerrarModalCredenciales() {
      this.mostrarModalCredenciales = false;
      this.hotelEditando = null;
      this.adminPasswordVerificado = '';
    },

    async guardarCredenciales() {
      const { usuario, contraseña } = this.credencialesForm;
      if (!usuario || !contraseña) return;

      try {
        await actualizarCredencialesHotel(this.hotelEditando.id, this.adminPasswordVerificado, usuario, contraseña);
      } catch (error) {
        Swal.fire({ icon: 'error', title: 'No se pudo actualizar', text: error.message, confirmButtonColor: '#d33' });
        return;
      }

      this.cerrarModalCredenciales();
      this.cargarHoteles();
      Swal.fire({ icon: 'success', title: 'Credenciales actualizadas', confirmButtonColor: '#133E68' });
    },
  },
};
</script>

<style scoped>
/* ---------- LAYOUT ---------- */
.dashboard-contenedor {
  display: flex;
  min-height: 100vh;
  background: var(--brand-beige);
}

.contenido {
  flex-grow: 1;
  padding: 28px 32px;
  margin-left: 250px;
  transition: margin-left 0.3s ease;
}

.contenido-expandido { margin-left: 80px; }

/* ---------- HEADER ---------- */
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--brand-accent-sage);
  margin: 0 0 4px;
}

.titulo {
  font-size: 26px;
  font-weight: 700;
  color: var(--brand-primary);
  margin: 0;
}

.btn-agregar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 20px;
  background: var(--brand-primary);
  color: var(--white);
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s, transform 0.15s;
}

.btn-agregar:hover { background: var(--brand-accent-navy); transform: translateY(-1px); }
.btn-agregar .material-icons {
  font-size: 20px;
}

.header-acciones {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.toggle-eliminados {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--brand-secondary);
  cursor: pointer;
  white-space: nowrap;
}

.fila-eliminada { opacity: 0.55; }

.btn-eliminar:hover { color: #d33; background: rgba(211, 51, 51, 0.08); }
.btn-restaurar:hover { color: var(--brand-accent-sage); background: rgba(96, 127, 112, 0.12); }

/* ---------- ESTADO DE CARGA ---------- */
.estado-cargando {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 80px 24px;
  color: var(--brand-primary);
  font-weight: 600;
}

.spinner {
  width: 44px;
  height: 44px;
  border: 4px solid rgba(19, 62, 104, 0.12);
  border-top-color: var(--brand-accent-sage, #607f70);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ---------- ESTADO VACÍO ---------- */
.estado-vacio {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 80px 24px;
  color: var(--brand-secondary-light);
}

.estado-icon { font-size: 64px; opacity: 0.3; }
.estado-vacio p { font-size: 15px; font-weight: 500; margin: 0; }

/* ---------- TABLA ---------- */
.tabla-card {
  background: var(--white);
  border-radius: 14px;
  box-shadow: 0 4px 16px rgba(19, 62, 104, 0.08);
  overflow: hidden;
}

.tabla-scroll { overflow-x: auto; }

.tabla {
  width: 100%;
  min-width: 600px;
  border-collapse: collapse;
}

.tabla thead {
  background: var(--brand-primary);
  color: var(--white);
}

.tabla th {
  padding: 13px 16px;
  font-size: 12px;
  font-weight: 700;
  text-align: left;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  white-space: nowrap;
}

.th-centro { text-align: center; }
.th-cp, .td-cp { width: 90px; text-align: center; }
.th-usuario, .td-mono { width: 130px; }
.th-credenciales { width: 130px; }
.th-acciones { width: 120px; }

.tabla tbody tr {
  border-bottom: 1px solid rgba(19, 62, 104, 0.07);
  transition: background 0.15s;
}

.tabla tbody tr:last-child { border-bottom: none; }
.tabla tbody tr:hover { background: rgba(96, 127, 112, 0.06); }

.tabla td {
  padding: 13px 16px;
  font-size: 14px;
  color: var(--brand-secondary);
  vertical-align: middle;
}

.td-nombre { font-weight: 700; color: var(--brand-primary); }
.td-mono { font-family: 'Courier New', monospace; font-size: 13px; }
.td-centro {
  text-align: center;
  white-space: nowrap;
}

.acciones-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* ---------- OJO ---------- */
.btn-ojo {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--brand-accent-sage);
  padding: 4px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  transition: color 0.2s, background 0.2s;
}

.btn-ojo:hover {
  color: var(--brand-primary);
  background: rgba(19, 62, 104, 0.08);
}

.btn-ojo .material-icons { font-size: 20px; }

/* ══════════════════════════════════════════
   MODAL REGISTRO
══════════════════════════════════════════ */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1400;
  padding: 16px;
}

.modal-registro {
  width: min(560px, 95vw);
  max-height: 86vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--white);
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
}

.modal-reg-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 22px;
  background: var(--brand-primary);
  border-radius: 16px 16px 0 0;
}

.modal-reg-header h3 {
  margin: 0 0 2px;
  font-size: 17px;
  font-weight: 700;
  color: var(--white);
}

.modal-reg-header p {
  margin: 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

.btn-close-modal {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  transition: color 0.2s;
}

.btn-close-modal:hover { color: var(--white); }

/* ---------- FORM ---------- */
.modal-form {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  gap: 0;
  padding: 0;
}

.modal-body-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 18px 22px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overscroll-behavior: contain;
}

.modal-body-scroll::-webkit-scrollbar {
  width: 7px;
}

.modal-body-scroll::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.modal-body-scroll::-webkit-scrollbar-thumb {
  background: #9ab4a7;
  border-radius: 4px;
}

.modal-body-scroll::-webkit-scrollbar-thumb:hover {
  background: var(--brand-primary);
}

.modal-seccion {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.modal-sec-titulo {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  color: var(--brand-accent-sage);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(96, 127, 112, 0.2);
}

.modal-sec-titulo .material-icons { font-size: 16px; }

/* ---------- CAMPOS ---------- */
.campo-grid { display: grid; gap: 12px; }
.campo-cols-2 { grid-template-columns: repeat(2, 1fr); }

.campo {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.campo-cp { max-width: 180px; }

label {
  font-size: 12px;
  font-weight: 600;
  color: var(--brand-secondary);
}

.req { color: #e03131; }

input {
  width: 100%;
  padding: 9px 12px;
  border: 2px solid var(--brand-secondary-light);
  border-radius: 8px;
  font-size: 13px;
  color: var(--brand-secondary);
  background: var(--white);
  box-sizing: border-box;
  transition: border-color 0.2s, box-shadow 0.2s;
}

input:focus {
  outline: none;
  border-color: var(--brand-accent-sage);
  box-shadow: 0 0 0 3px rgba(96, 127, 112, 0.15);
}

/* ---------- FOOTER ---------- */
.modal-footer {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 22px;
  background: var(--white);
  border-top: 1px solid #e8edf2;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.04);
  flex-wrap: wrap;
}

.btn-cancelar {
  padding: 10px 20px;
  border: 2px solid var(--brand-secondary-light);
  border-radius: 8px;
  background: transparent;
  color: var(--brand-secondary);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.btn-cancelar:hover { border-color: var(--brand-secondary); color: var(--brand-primary); }

.btn-registrar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 22px;
  background: var(--brand-accent-sage);
  color: var(--white);
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s, transform 0.15s;
}

.btn-registrar:hover { background: var(--brand-accent-navy); transform: translateY(-1px); }
.btn-registrar .material-icons { font-size: 16px; }

/* ---------- RESPONSIVE ---------- */
@media (max-width: 1024px) {
  .contenido { margin-left: 80px; }
}

@media (max-width: 768px) {
  .dashboard-contenedor { flex-direction: column; }
  .contenido { margin-left: 0 !important; padding: 12px; padding-top: 70px; }
  .campo-cols-2 { grid-template-columns: 1fr; }
  .titulo { font-size: 20px; }
}
</style>
